/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import ViewTravelQuotePage from './ViewTravelQuotePage';

export default ViewTravelQuotePage;
